export class ResidentRuleItemResultDto {
  ruleType: string;
  ruleText: string;
  appliesTo: string;
}
